<script setup lang="ts">
import { main_menu } from '~/common/main_menu'
import AdminMenuItem from './AdminMenuItem.vue'
/**
 *
 *  Props and emits section
 *
 *
*/

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const router = useRouter()

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/
const handleClick = (route?: string) => {
    if (route) {
        router.push(route)
    }
}
</script>

<template>
    <template v-for="menu in main_menu">
        <div class="tw-flex tw-gap-4 tw-px-6 tw-w-full" @click="handleClick(menu.route)">
            <span class="tw-text-adminAccent-300 tw-mt-4">{{ $t(menu.title) }}</span>
        </div>
        <template v-if="menu.children && menu.children.length > 0">
            <AdminMenuItem :menu="menu.children" />
        </template>
    </template>
</template>
